import { createContext } from "react";
import { VspPortalState, initialVspPortalState } from "./VspPortalState";


const VspPortalContext = createContext<{
    state: VspPortalState;
    dispatch: React.Dispatch<any>;
  }>({
    state: initialVspPortalState,
    dispatch: () => null
  });

  export default VspPortalContext;
  
